import React, { createContext, useContext, useState } from "react";

// Shares the landing "Worker / Business" toggle between the hero (which owns
// the toggle) and the layout chrome above it (the Founding-seats org banner,
// which should only show to the hiring audience). Defaults to "professional"
// so we lead with the individual/worker; the org-oriented promos surface once
// a visitor flips to the Business side.
const AudienceModeContext = createContext({ mode: "professional", setMode: () => {} });

export function AudienceModeProvider({ children }) {
  const [mode, setMode] = useState("professional");
  return (
    <AudienceModeContext.Provider value={{ mode, setMode }}>
      {children}
    </AudienceModeContext.Provider>
  );
}

export function useAudienceMode() {
  return useContext(AudienceModeContext);
}
